import { GameMoveableObstacleTypeEnum, GameObstacleTypeEnum, GamePlayerTypeEnum } from '../Models/GameModel';
import { CarModel } from '../Models/CarModel';

/**
 * x - слабые, y - средние, z - слиьные
 * 
 * x = 1x
 * y = 2x
 * z = 1x
 * k1x+k2y+k3z = 2000
 * x(k1+2k2+k3) = 2000
 * x = 2250 / (k1+2k2+k3);
 * x = 2000 / (2 + 4+2);
 * x = 2000/8 = 250;
 */

/**
 * x - расстояние между обхектами
 * k1, k2, k3 - кол-во объектов
 * S - длина сегмента
 * x(k1+2k2+k3) = S
 * k1/k2/k3 = 9/3/1
 * k1/k2 = 3/1
 * k2/k3 = 3/1
 * k1/k3 = 9/1
 * 14000 / 250 = 56
 *  k1+2k2+k3 = 56
 *  k1+2*1/3k1 + 1/9k1 = 56
 *  1.(7)k1 = 56
 * k1 = 31
 * k2 = 10
 * k3 = 3
 * 
 */


/**
 * speed = speed_default * (boost*speed_default*0.8)
 */
const GameConfig = {
    'common': {
        'speedMax': 1000,
        'accelerationMax': 300,
        'gasRateMax': 10,
        'handleabilityMax': 30,
        'coinPerDistance': 0.01,
        'obstacleDistance': 100,
        'beforeCheckPoint': 0,
        'beforeStatic': 400,
    },
    "tiles": [
        {
            "distance": 2250,
            "obstacles": [5,1,0],
        },
        {
            "distance": 3250,
            "obstacles": [6,2,0],
        },
        {
            "distance": 3750,
            "obstacles": [7,2,1],
        },
        {
            "distance": 4250,
            "obstacles": [9,3,1],
        },
        {
            "distance": 4750,
            "obstacles": [10,3,2],
        },
        {
            "distance": 5250,
            "obstacles": [13,5,3],
        },
        {
            "distance": 5750,
            "obstacles": [24,9,3],
        },
        {
            "distance": 6250,
            "obstacles": [29,9,3],
        },
        {
            "distance": 6750,
            "obstacles": [30,10,4],
        },
        {
            "distance": 7500,
            "obstacles": [35,11,4],
        },
        {
            "distance": 8250,
            "obstacles": [38,12,4],
        },
        {
            "distance": 9000,
            "obstacles": [41,14,4],
        },
        {
            "distance": 10000,
            "obstacles": [47,15,5],
        },
        {
            "distance": 11000,
            "obstacles": [51,17,5],
        },
        {
            "distance": 12500,
            "obstacles": [60,19,6],
        },
        {
            "distance": 14500,
            "obstacles": [64,22,7],
        }
    ],
    'cars': [
        {
            'title': 'title_car_1',
            'price': 0,
            'speed': 250,
            'acceleration': 90,
            'gasRate': 3,
            'handleability': 5,
            'repairPrice': 0,
        },
        {
            'title': 'title_car_2',
            'price': 10000,
            'speed': 300,
            'acceleration': 100,
            'gasRate': 3,
            'handleability': 10,
            'repairPrice': 200,
        },
        {
            'title': 'title_car_3',
            'price': 25000,
            'speed': 350,
            'acceleration': 125,
            'gasRate': 3,
            'handleability': 20,
            'repairPrice': 200,
        },
        {
            'title': 'title_car_4',
            'price': 50000,
            'speed': 400,
            'acceleration': 150,
            'gasRate': 3,
            'handleability': 20,
            'repairPrice': 200,
        },
    ],
    'upgrades': [
        {
            title: 'Антикрыло',
            price: 9000,
            maxSpeed: 100,
            acceleration: 0,
            fuelRate: 0,
        },
        {
            title: 'Турбонаддув',
            price: 1000,
            maxSpeed: 0,
            acceleration: 50,
            fuelRate: 0,
        },
        {
            title: 'Двигатель',
            price: 5000,
            maxSpeed: 0,
            acceleration: 0,
            fuelRate: 1,
        },
    ],
    paint: [
        {
            color: 'green',
            price: '0',
        },
        {
            color: 'red',
            price: '2000',
        },
        {
            color: 'blue',
            price: '2000',
        },
        {
            color: 'purple',
            price: '3000',
        },
    ],
    obstacles: [],
    levels: [
        {
            price: 0,
        },
        {
            price: 10000,
        }
    ]
};

GameConfig.obstacles['horse'] = {
    price: 100,
}
GameConfig.obstacles['degen'] = {
    price: 100,
}
GameConfig.obstacles['police'] = {
    price: 200,
}
GameConfig.obstacles['policeCrown'] = {
    price: 200,
}
GameConfig.obstacles['gelandewagen'] = {
    price: 200,
}

const getCommonConfig = (prop: string): any => {
    return GameConfig.common[prop];
};

const getCarConfig = (index: number, prop: string = undefined): any => {
    return typeof prop === 'undefined' ? GameConfig.cars[index] : GameConfig.cars[index][prop];
};

const getUpgradeConfig = (index: number, prop: string = undefined): any => {
    return typeof prop === 'undefined' ? GameConfig.upgrades[index] : GameConfig.upgrades[index][prop];
};

const getPaintConfig = (index: number, prop: string = undefined): any => {
    return typeof prop === 'undefined' ? GameConfig.paint[index] : GameConfig.paint[index][prop];
};

const getCarConfigByType = (type: GamePlayerTypeEnum, prop: string = undefined): any => {
    const values = Object.values(GamePlayerTypeEnum);
    const index = values.indexOf(type);

    return getCarConfig(index - 1, prop);
};

const getObstacleConfig = (type: GameMoveableObstacleTypeEnum | GameObstacleTypeEnum, prop: string) => {
    return typeof prop === 'undefined' ? GameConfig.obstacles[type] : GameConfig.obstacles[type][prop];
}

const getLevelConfig = (index, prop: string) => {
    return typeof prop === 'undefined' ? GameConfig.levels[index] : GameConfig.levels[index][prop];
}

const getTileConfig = (index: number): any => {
    const tiles = GameConfig.tiles;
    return index >= tiles.length ? tiles[tiles.length - 1] : tiles[index];
};

export const getAvailableUpgradeBoost = (carModel: CarModel): { speed: number, acceleration: number, gasRate: number } => {
    let speed = 0;
    let acceleration = 0;
    let gasRate = 0;

    carModel.upgrades.forEach((available, index) => {
        if (available) {
            const config = getUpgradeConfig(index);

            if (config.hasOwnProperty('maxSpeed')) {
                speed += config.maxSpeed;
            }
            if (config.hasOwnProperty('acceleration')) {
                acceleration += config.acceleration;
            }
            if (config.hasOwnProperty('fuelRate')) {
                gasRate += config.fuelRate;
            }
        }
    });

    return { speed, acceleration, gasRate };
}

export {
    getCarConfig,
    getCommonConfig,
    getCarConfigByType,
    getTileConfig,
    getUpgradeConfig,
    getPaintConfig,
    getObstacleConfig,
    getLevelConfig,
};
